import React, { useRef, useState } from 'react'
import Navbar from '../componenets/Navbar'
import bgImage from '../Images/project1.jpeg'
import Project_img1 from '../Images/wm2.jpeg'
import Project_img2 from '../Images/wm3.jpeg'
import Project_img3 from '../Images/wm4.jpeg'
import Project_img4 from '../Images/Wm1.jpeg'
import Project_img5 from '../Images/wb1.jpeg'
import Project_img6 from '../Images/Wb5.jpeg'
import Project_img7 from '../Images/wb3.jpeg'
import Project_img8 from '../Images/wb4.jpeg'
import Project_img9 from '../Images/fish2.jpeg'
import Project_img10 from '../Images/fishing.jpeg'
import Project_img11 from '../Images/c3.jpeg'
import Footer from '../componenets/Footer'
import { BsArrowLeft, BsArrowRight } from 'react-icons/bs'

const Projects = () => {
     

      const scrollRef = useRef(null);
    
      const [leftActive, setLeftActive] = useState(false);

      const scroll = (direction) => {
        const { current } = scrollRef;
      
        if (direction === "right") {
          setLeftActive(true); // left becomes active
        }
      
        if (direction === "left") {
          setLeftActive(false); // optional: left goes back to default
        }
      
        if (current) {
          const scrollAmount = 300;
          current.scrollBy({
            left: direction === "left" ? -scrollAmount : scrollAmount,
            behavior: "smooth",
          });
        }
      };



  const images = [
    Project_img1, Project_img2, Project_img3, Project_img4,
  ];

  const imagese = [
    Project_img5, Project_img6, Project_img7, Project_img8,
  ];

  const image = [
    Project_img9, Project_img10, Project_img11, 
  ];  
    
    
 
  return (
    <div>
        <Navbar />


    <section className="about_who-we-are"
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <div className="about_who-we-are-content">
        <p className="about_tag">Our Projects</p>
        <h1>Proven Field Success Through Innovation and Expertise.</h1>
      </div>
    </section>

    <section className="border_bottom_divs wow animate__animated animate__fadeInUp" >
        <h2>Precision maintenance for safe, reliable, long-lasting wellheads</h2>        
    </section>
    <hr className='hr_line'/> 

    <section className="services_detail_text wow animate__animated animate__fadeInUp" data-wow-delay="0.3s">
        <p>WellClean delivers comprehensive wellhead maintenance solutions to preserve equipment integrity, enhance reliability, and extend asset life.</p>
        <p>Our services include routine inspections, valve servicing, corrosion control, leak detection, and replacement of critical components.</p>
        <p>We prioritize safety, equipment reliability, and operational excellence to keep wellheads functioning optimally in challenging field environments.</p>
    </section>  

    <div className="project_work wow animate__animated animate__fadeInUp" data-wow-delay="0.3s">
    <div className="project_ontrol_btn">
      <button
        className={leftActive ? "active" : ""}
        onClick={() => scroll("left")}
      >
        <BsArrowLeft />
      </button>

      <button className="active" onClick={() => scroll("right")}>
        <BsArrowRight />
      </button>
    </div>
        <div className="project_img_carrier">
           <div className="project_container" ref={scrollRef}>
            {images.map((img, index) => (
                <div className="project_work_items" key={index}>
                <img src={img} alt={`project-${index}`} />
                </div>
            ))}
           </div>
        </div>
    </div> 

    <hr className='hr_line'/> 



    <section className="border_bottom_divs wow animate__animated animate__fadeInUp" >
        <h2>Precision maintenance for safe, reliable, long-lasting wellheads</h2>        
    </section>
    <hr className='hr_line'/> 

    <section className="services_detail_text wow animate__animated animate__fadeInUp" data-wow-delay="0.3s">
        <p>WellClean delivers comprehensive wellhead maintenance solutions to preserve equipment integrity, enhance reliability, and extend asset life.</p>
        <p>Our services include routine inspections, valve servicing, corrosion control, leak detection, and replacement of critical components.</p>
        <p>We prioritize safety, equipment reliability, and operational excellence to keep wellheads functioning optimally in challenging field environments.</p>
    </section>  

    <div className="project_work wow animate__animated animate__fadeInUp" data-wow-delay="0.3s">
    <div className="project_ontrol_btn">
      <button
        className={leftActive ? "active" : ""}
        onClick={() => scroll("left")}
      >
        <BsArrowLeft />
      </button>

      <button className="active" onClick={() => scroll("right")}>
        <BsArrowRight />
      </button>
    </div>
        <div className="project_img_carrier">
           <div className="project_container" ref={scrollRef}>
            {imagese.map((img, index) => (
                <div className="project_work_items" key={index}>
                <img src={img} alt={`project-${index}`} />
                </div>
            ))}
           </div>
        </div>
    </div>    
          
    <hr className='hr_line'/> 

    <section className="border_bottom_divs wow animate__animated animate__fadeInUp" >
        <h2>Precision maintenance for safe, reliable, long-lasting wellheads</h2>        
    </section>
    <hr className='hr_line'/> 

    <section className="services_detail_text wow animate__animated animate__fadeInUp" data-wow-delay="0.3s">
        <p>WellClean delivers comprehensive wellhead maintenance solutions to preserve equipment integrity, enhance reliability, and extend asset life.</p>
        <p>Our services include routine inspections, valve servicing, corrosion control, leak detection, and replacement of critical components.</p>
        <p>We prioritize safety, equipment reliability, and operational excellence to keep wellheads functioning optimally in challenging field environments.</p>
    </section>  

    <div className="project_work wow animate__animated animate__fadeInUp" data-wow-delay="0.3s">
    <div className="project_ontrol_btn">
      <button
        className={leftActive ? "active" : ""}
        onClick={() => scroll("left")}
      >
        <BsArrowLeft />
      </button>

      <button className="active" onClick={() => scroll("right")}>
        <BsArrowRight />
      </button>
    </div>
        <div className="project_img_carrier">
           <div className="project_container" ref={scrollRef}>
            {image.map((img, index) => (
                <div className="project_work_items" key={index}>
                <img src={img} alt={`project-${index}`} />
                </div>
            ))}
           </div>
        </div>
    </div>     

    <Footer />
    </div>
  )
}

export default Projects
